<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 256 256" enable-background="new 0 0 256 256" xml:space="preserve">
<metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
    <g><g><path fill="#8c8c8c" d="M10,123.8h219.1v8.4H10V123.8z"/>
      <path fill="#8c8c8c"
                                                                        d="M203.9,115.4L246,128l-42.1,12.6V115.4z"/></g></g>
</svg>
</template>

<script>
export default {}
</script>
